export default {
  // EuSortDialog.vue
  'crud.EuSortDialog.title': '设置排序规则',
  'crud.EuSortDialog.addRuleBtn': '添加排序规则',
  'crud.EuSortDialog.asc': '升序',
  'crud.EuSortDialog.desc': '降序',
  'crud.EuSortDialog.clear': '清空排序',
  'crud.EuSortDialog.cancel': '取 消',
  'crud.EuSortDialog.submit': '排 序',
  // EuTableToolbar.vue
  'crud.EuTableToolbar.add': '新增',
  'crud.EuTableToolbar.del': '批量删除',
  'crud.EuTableToolbar.export': '导出',
  'crud.EuTableToolbar.import': '导入',
  // IconSelect.vue
  'crud.IconSelect.placeholder': '输入要查找的图标拼音',
  // ImportDialog.vue
  'crud.ImportDialog.title': '导入',
  'crud.ImportDialog.tplFilePrefix': '模版',
  'crud.ImportDialog.steps1Title': '上传Excel',
  'crud.ImportDialog.steps2Title': '导入数据',
  'crud.ImportDialog.importMode': '导入模式：',
  'crud.ImportDialog.importMode.add': '仅新增数据',
  'crud.ImportDialog.importMode.update': '更新数据',
  'crud.ImportDialog.importMode.addAndUpdate': '新增和更新数据',
  'crud.ImportDialog.tip': '为保证数据导入顺利，推荐您使用',
  'crud.ImportDialog.tip.standardTpl': '标准模板',
  'crud.ImportDialog.tip.support': '支持 {sizeLimit}MB 以内的xls、xlsx格式文件',
  'crud.ImportDialog.upload.tip': '单个文件不超过{sizeLimit}MB',
  'crud.ImportDialog.upload.text': '将文件拖到此处，或<em>点击上传</em>',
  'crud.ImportDialog.success.update': '导入完成,更新',
  'crud.ImportDialog.success.add': '条数据，新增',
  'crud.ImportDialog.success.suffix': '条数据',
  'crud.ImportDialog.complete.prev': '上一步',
  'crud.ImportDialog.complete.submit': '完成',
  // Message
  'message.head1.text': '通知',
  'message.head2.text': '公告',
  'message.loading': '加载中...',
  'message.noData': '暂无数据',
  'message.close': '关闭',
  'message.allRead': '全部已读',
  // TableColumnSettingDialog.vue
  'crud.TableColumnSettingDialog.title': '设置表格列',
  'crud.TableColumnSettingDialog.reset': '重置预设',
  'crud.TableColumnSettingDialog.cancel': '取 消',
  'crud.TableColumnSettingDialog.submit': '确 定',
  'crud.TableColumnSettingDialog.column1': '列名称',
  'crud.TableColumnSettingDialog.column2': '是否显示',
  'crud.TableColumnSettingDialog.column3': '调整顺序',
  'crud.TableColumnSettingDialog.column4': '冻结列',
  // UploadFile.vue
  'crud.UploadFile.trigger': '点击上传',
  'crud.UploadFile.uploadFail': '上传失败',
  'crud.UploadFile.size.limit': '上传文件大小不能超过{limit}MB',
  'crud.UploadFile.number.limit': '最多上传{limit}个文件',
  // AppContainerTabs.vue
  'layout.AppContainerTabs.refresh': '刷新',
  'layout.AppContainerTabs.closeOther': '关闭其他',
  'layout.AppContainerTabs.closeLeft': '关闭左侧',
  'layout.AppContainerTabs.closeRight': '关闭右侧',
  'layout.AppContainerTabs.closeAll': '关闭全部',
  // InnerIframe.vue
  'layout.InnerIframe.loading': '加载中...',
  // SidebarHeader
  'layout.SidebarHeader.username': '登录名：',
  'layout.SidebarHeader.nickname': '姓名：',
  'layout.SidebarHeader.email': '邮箱：',
  'layout.SidebarHeader.deptNames': '部门：',
  'layout.SidebarHeader.personCenter': '个人中心',
  'layout.SidebarHeader.logout': '退出登录',
  'layout.SidebarHeader.noDept': '暂无部门',
  'layout.SidebarHeader.logout.confirm.message': '确定退出登录吗？',
  'layout.SidebarHeader.logout.confirm.title': '提示',
  'layout.SidebarHeader.logout.confirm.confirmButtonText': '确定',
  'layout.SidebarHeader.logout.confirm.cancelButtonText': '取消',
  // ThemeConfig
  'layout.ThemeConfig.title': '主题配置',
  'layout.ThemeConfig.form.layout': '布局',
  'layout.ThemeConfig.form.layout.column': '分栏布局：推荐子菜单较多的场景使用',
  'layout.ThemeConfig.form.layout.vertical': '垂直布局',
  'layout.ThemeConfig.form.layout.uniqueOpened': '是否只保持一个子菜单的展开',
  'layout.ThemeConfig.form.showTabsBar': '标签页',
  'layout.ThemeConfig.form.fixedTabsBar': '固定标签',
  'layout.ThemeConfig.form.showProgressBar': '进度条',
  'layout.ThemeConfig.form.enabledWatermark': '开启水印',
  'layout.ThemeConfig.form.darkMode': '暗黑模式',
  'layout.ThemeConfig.submit': '保存',
  'layout.ThemeConfig.restore': '恢复默认',
  // ElementDatePickerOptions
  'elementDatePickerOptions.shortcuts.lastWeek': '最近一周',
  'elementDatePickerOptions.shortcuts.lastMonth': '最近一个月',
  'elementDatePickerOptions.shortcuts.lastThreeMonths': '最近三个月',
  'elementDatePickerOptions.shortcuts.lastSixMonths': '最近半年',
  'elementDatePickerOptions.shortcuts.lastYear': '最近一年',
  // 操作日志
  'const.BusinessTypeEnums.OTHER': '其他',
  'const.BusinessTypeEnums.QUERY': '查询',
  'const.BusinessTypeEnums.INSERT': '新增',
  'const.BusinessTypeEnums.UPDATE': '修改',
  'const.BusinessTypeEnums.DELETE': '删除',
  'const.BusinessTypeEnums.EXPORT': '导出',
  'const.BusinessTypeEnums.EXPORT_TEMPLATE': '导出模版',
  'const.BusinessTypeEnums.IMPORT': '导入',
  'const.BusinessTypeEnums.LOGIN': '登录',
  'const.BusinessTypeEnums.LOGOUT': '登出',
  'const.BusinessTypeEnums.KICKOUT': '踢人下线',
  'const.BusinessTypeEnums.FORCE_LOGOUT': '强制注销',
  'const.BusinessTypeEnums.PAUSE_RESUME_JOB': '暂停/恢复任务',
  'const.BusinessTypeEnums.EXEC_JOB': '执行任务',
  // 菜单类型
  'const.MenuTypeEnums.DIR': '目录',
  'const.MenuTypeEnums.MENU': '菜单',
  'const.MenuTypeEnums.BUTTON': '按钮',
  // 数据权限
  'const.DataScopeEnums.ALL': '全部数据权限',
  'const.DataScopeEnums.CUSTOM': '自定数据权限',
  'const.DataScopeEnums.DEPT': '部门数据权限',
  'const.DataScopeEnums.DEPT_AND_CHILD': '部门及以下数据权限',
  'const.DataScopeEnums.SELF': '仅本人数据权限',
  // 通知类型
  'const.NoticeTypeEnums.INFO': '通知',
  'const.NoticeTypeEnums.ANNOUNCEMENT': '公告',
  // errorCode
  'errorCode.401': '认证失败，无法访问系统资源',
  'errorCode.403': '当前操作没有权限',
  'errorCode.404': '访问资源不存在',
  'errorCode.default': '系统未知错误，请反馈给管理员',
  // request
  'request.error.network': '后端接口连接异常',
  'request.error.timeout': '系统接口请求超时',
  'request.error.failed': '系统接口{msg}异常',
  'request.error.unauthorized': '{msg},请重新登录',
  'request.download.loading': '正在下载数据，请稍候',
  'request.download.success': '操作成功',
  'request.download.error': '下载文件出现错误，请联系管理员',
  // General
  'general.add': '新增',
  'general.edit': '修改',
  'general.del': '删除',
  'general.confirm.title': '提示',
  'general.confirm.cancel': '取消',
  'general.confirm.confirm': '确定',
  'general.confirm.delete.success': '删除成功',
  'general.confirm.save.success': '保存成功',
  'general.confirm.delete.batch.message': '确认要删除选中的{length}条记录吗？',
  'general.confirm.delete.message': '确认要删除"{key}"吗？',
  'general.form.cancel': '取 消',
  'general.form.submit': '保 存',
  'general.placeholder.input': '输入{field}',
  'general.placeholder.select': '选择{field}',
  'general.required': '{field}不能为空',
  'general.query.reset': '重置',
  'general.query.search': '查询',
  'general.column.operation': '操作',
  'general.placeholder.enter.search': '回车搜索',
  'general.back.prev': '返回上一页',
  'general.info.basic': '基本信息',
  'general.reload': '重新加载',
  'general.error.linkMissParams': '链接地址缺少参数',
  'general.error.dataLoad': '数据加载异常',
  'general.submit.add.success': '新增成功',
  'general.submit.update.success': '更新成功',
  'general.submit.update.success.tips': '您可以停在当前页继续编辑，或者返回上一页?',
  'general.submit.update.success.tips.goPrev': '返回上一页',
  'general.submit.update.success.tips.stay': '停留在当前页',
  // 401
  '401.title': '抱歉，您没有权限访问该页面',
  '401.desc1': '解决办法：',
  '401.desc2': '您可以向上级领导申请开通该权限',
  '401.back': '回到上一个页面',
  // 404
  '404.title': '抱歉，页面暂时无法访问',
  '404.from': '来源：',
  '404.desc1': '可能有以下原因：',
  '404.desc2': '网址错误：请检查地址是否完整或存在多余字符',
  '404.desc3': '网络问题：请检查网络是否已连接',
  '404.desc4': '网址失效：可能页面已被删除',
  '404.back': '回到首页',
  '404.back.prev': '返回上一页',
}
